module.exports = __webpack_public_path__ + "static/33-edeb24cd437d29ccbb069ef235eceb24.png";